export const Assets = [
    {
        url: '/images/disp_map.png',
        name: 'displacement_map'
    }
]